module.exports = __webpack_public_path__ + "static/img/Compared@2x.0bffb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbConsociation/Compared@2x.png
// module id = GHcz
// module chunks = 70